import React, { useState,Component } from 'react';
import axios from 'axios';
import { setUserSession } from '../utils/Common';
import { BrowserRouter, Switch, Route, NavLink } from 'react-router-dom';
import {Footer} from 'react-materialize';
import DataService from "../services/data.service";
import Message from '../component/Message';
import Loading from '../component/loading';
import { withRouter } from 'react-router-dom';
import createHistory from 'history/createBrowserHistory'

class Payload_not_found extends Component {
  constructor(props) {
    super(props);

    this.state = {
    
     
    }
   
   
  }

    render() {
        return (

            <div id="error" className="">
             
             
           
	
	<h3 class="mt-5">Oops, This Page Isn't Available</h3>
	<p>Use the links below to continue your search.</p>
	
	<div class="container">
		<ul>
			<li><a href="https://www.neimanmarcus.com/c/womens-clothing-cat58290731?icid=error_Wom"><strong>Women's Clothing</strong></a></li>
			<li><a href="https://www.neimanmarcus.com/c/womens-clothing-clothing-dresses-cat43810733?icid=error_Wom_Dress">Dresses</a></li>
			<li><a href="https://www.neimanmarcus.com/c/womens-clothing-clothing-tops-cat42960827?icid=error_Wom_Top">Tops</a></li>
			<li><a href="https://www.neimanmarcus.com/c/womens-clothing-clothing-jeans-cat44640769?icid=error_Wom_Jean">Jeans</a></li>
		</ul>
		<ul>
			<li><a href="https://www.neimanmarcus.com/c/shoes-all-designer-shoes-cat47190746?icid=error_Shoe"><strong>Shoes</strong></a></li>
			<li><a href="https://www.neimanmarcus.com/c/shoes-all-designer-shoes-sandals-cat48490746?icid=error_Shoe_Sandals">Sandals</a></li>
			<li><a href="https://www.neimanmarcus.com/c/shoes-all-designer-shoes-pumps-heels-cat68670755?icid=error_Shoe_Pump">Pumps</a></li>
			<li><a href="https://www.neimanmarcus.com/c/shoes-all-designer-shoes-boots-cat45140734?icid=error_Shoe_Boots">Boots</a></li>
		</ul>
		<ul>
			<li><a href="https://www.neimanmarcus.com/c/handbags-all-handbags-cat46860739?icid=error_Hand"><strong>Handbags</strong></a></li>
			<li><a href="https://www.neimanmarcus.com/c/handbags-handbags-totes-cat40860745?icid=error_Hand_Tote">Tote Bags</a></li>
			<li><a href="https://www.neimanmarcus.com/c/handbags-all-handbags-crossbody-bags-cat42600741?icid=error_Hand_Cross">Crossbody Bags</a></li>
			<li><a href="https://www.neimanmarcus.com/c/handbags-all-handbags-clutches-pouches-cat13410735?icid=error_Hand_Clutch">Clutches</a></li>
		</ul>
		<ul>
			<li><a href="https://www.neimanmarcus.com/c/jewelry-accessories-cat50910737?icid=error_Jew"><strong>Jewelry</strong></a></li>
			<li><a href="https://www.neimanmarcus.com/c/jewelry-accessories-jewelry-necklaces-cat4870734?icid=error_Jew_Neck">Necklaces</a></li>
			<li><a href="https://www.neimanmarcus.com/c/jewelry-accessories-jewelry-earrings-cat4870732?icid=error_Jew_Ear">Earrings</a></li>
			<li><a href="https://www.neimanmarcus.com/c/jewelry-accessories-jewelry-bracelets-cat4870733?icid=error_Jew_Bracelet">Bracelets</a></li>
		</ul>
		<ul>
			<li><a href="https://www.neimanmarcus.com/c/jewelry-accessories-cat51730760?icid=error_Acc"><strong>Accessories</strong></a></li>
			<li><a href="https://www.neimanmarcus.com/c/jewelry-accessories-accessories-scarves-wraps-cat41270753?icid=error_Acc_Scarves">Scarves &amp; Wraps</a></li>
			<li><a href="https://www.neimanmarcus.com/c/jewelry-accessories-accessories-hats-gloves-cat51770734?icid=error_Acc_Hats">Hats &amp; Gloves</a></li>
			<li><a href="https://www.neimanmarcus.com/c/jewelry-accessories-accessories-sunglasses-cat45330747?icid=error_Acc_Sunglasses">Sunglasses</a></li>
		</ul>
		<ul>
			<li><a href="https://www.neimanmarcus.com/c/beauty-all-beauty-cat55180733?icid=error_Bea"><strong>Beauty</strong></a></li>
			<li><a href="https://www.neimanmarcus.com/c/beauty-skin-care-cat10470738?icid=error_Bea_Skin">Skin Care</a></li>
			<li><a href="https://www.neimanmarcus.com/c/beauty-makeup-cat10420742?icid=error_Bea_Mak">Makeup</a></li>
			<li><a href="https://www.neimanmarcus.com/c/beauty-fragrances-cat10470744?icid=error_Bea_Frag">Fragrances</a></li>
		</ul>
		<ul>
			<li><a href="https://www.neimanmarcus.com/c/mens-clothing-cat14120827?icid=error_Men"><strong>Men's Clothing</strong></a></li>
			<li><a href="https://www.neimanmarcus.com/c/mens-clothing-polos-t-shirts-cat13140748?icid=error_Men_Polo">Polos &amp; T-Shirts</a></li>
			<li><a href="https://www.neimanmarcus.com/c/mens-clothing-suits-cat48730755?icid=error_Men_Suit">Suits</a></li>
			<li><a href="https://www.neimanmarcus.com/c/mens-clothing-jeans-cat48720745?icid=error_Men_Jean">Jeans</a></li>
		</ul>
		<ul>
			<li><a href="https://www.neimanmarcus.com/c/kids-all-kids-cat58510733?icid=error_Kid"><strong>Kids</strong></a></li>
			<li><a href="https://www.neimanmarcus.com/c/kids-girls-cat10000733?icid=error_Kid_Girl">Girl's</a></li>
			<li><a href="https://www.neimanmarcus.com/c/kids-boys-cat13820742?icid=error_Kid_Boy">Boy's</a></li>
			<li><a href="https://www.neimanmarcus.com/c/kids-toy-shop-gifts-cat74890761?icid=error_Kid_Toy">Toys &amp; Gifts</a></li>
		</ul>
		<ul>
			<li><a href="https://www.neimanmarcus.com/c/home-all-home-cat59040731?icid=error_Hom"><strong>Home</strong></a></li>
			<li><a href="https://www.neimanmarcus.com/c/home-dining-entertaining-cat40510812?icid=error_Hom_Dine">Dining &amp; Entertaining</a></li>
			<li><a href="https://www.neimanmarcus.com/c/home-bedding-cat47490756?icid=error_Hom_Bed">Bedding</a></li>
			<li><a href="https://www.neimanmarcus.com/c/home-furniture-cat47490757?icid=error_Hom_Furn">Furniture</a></li>
		</ul>
	</div>
	
	<h4>For Assistance:</h4>
    <lable>For information regarding fur storage and services please contact our fur specialists at Service@NMFurServices.com or .</lable>
	<p>Call <a href="tel:1-888-765-3877">1-888-765-3877</a></p>
              </div>
            
            
          );
    }
  
}
export default withRouter(Payload_not_found);
